var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","appear":""}},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"season":_vm.season,"config":_vm.env}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }